import clsx from 'clsx'
import { Field, FieldLabel } from '@/components/ui/field'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'

export interface SelectSerieItem {
  label: string
  id: string
}

interface SelectSerieProps {
  field?: {
    onChange?: (value: string) => void
    value?: string
  }
  disabledSelect?: boolean
  options: SelectSerieItem[]
}

export function SelectSerie({
  field,
  options,
  disabledSelect
}: SelectSerieProps) {
  return (
    <Field>
      <FieldLabel
        className={clsx('text-base text-muted-foreground/70', {
          'text-[var(--brand-slate-1)]': !disabledSelect
        })}
      >
        Série para o Aluno Ingressar
      </FieldLabel>

      <Select
        onValueChange={(value: string) => field?.onChange?.(value)}
        value={field?.value}
        disabled={disabledSelect}
      >
        <SelectTrigger className="w-64 bg-background">
          <SelectValue placeholder="Selecione" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {options.map((option) => (
              <SelectItem key={option.id} value={option.label}>
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </Field>
  )
}
